var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExtendedTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 324,
    height: 330,
    viewBox: "0 0 324 330",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 321,
    height: 327,
    fill: "url(#paint0_linear_908_1871)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M220.486 170.717L213.455 182.896L199.392 182.896L192.36 170.717L199.392 158.538L213.455 158.538L220.486 170.717Z",
    fill: "#3AEFEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223.984 170.717L215.202 185.928L197.638 185.928L188.856 170.717L197.638 155.506L215.202 155.506L223.984 170.717ZM211.701 161.57L201.139 161.57L195.858 170.717L201.139 179.864L211.701 179.864L216.982 170.717L211.701 161.57Z",
    fill: "url(#paint1_linear_908_1871)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M145.486 217.593L103.297 217.593L115.271 198.843L133.512 198.843L145.486 217.593Z",
    fill: "#3AEFEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.018 220.626L97.761 220.626L113.607 195.812L135.171 195.812L151.018 220.626ZM131.849 201.876L116.93 201.876L108.829 214.562L139.95 214.562L131.849 201.876Z",
    fill: "url(#paint2_linear_908_1871)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M227.521 217.593L185.332 217.593L197.306 198.843L215.548 198.843L227.521 217.593Z",
    fill: "#3AEFEF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.053 220.626L179.796 220.626L195.643 195.812L217.206 195.812L233.053 220.626ZM213.884 201.876L198.965 201.876L190.864 214.562L221.985 214.562L213.884 201.876Z",
    fill: "url(#paint3_linear_908_1871)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M185.334 151.966L174.787 170.234L153.692 170.234L143.145 151.966L153.692 133.697L174.787 133.697L185.334 151.966Z",
    fill: "#3AEFEF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.832 151.966L176.534 173.267L151.939 173.267L139.641 151.966L151.939 130.666L176.534 130.666L188.832 151.966ZM173.033 136.73L155.44 136.73L146.643 151.966L155.44 167.203L173.033 167.203L181.83 151.966L173.033 136.73Z",
    fill: "url(#paint4_linear_908_1871)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M197.051 217.594L131.423 217.594L150.05 187.124L178.425 187.124L197.051 217.594Z",
    fill: "#3AEFEF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M202.455 220.626L126.013 220.626L148.346 184.092L180.122 184.092L202.455 220.626ZM176.722 190.156L151.747 190.156L136.828 214.562L191.641 214.562L176.722 190.156Z",
    fill: "url(#paint5_linear_908_1871)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136.109 170.717L129.078 182.896L115.015 182.896L107.983 170.717L115.015 158.538L129.078 158.538L136.109 170.717Z",
    fill: "#3AEFEF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.607 170.717L130.825 185.928L113.261 185.928L104.479 170.717L113.261 155.506L130.825 155.506L139.607 170.717ZM127.324 161.57L116.762 161.57L111.481 170.717L116.762 179.864L127.324 179.864L132.605 170.717L127.324 161.57Z",
    fill: "url(#paint6_linear_908_1871)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.109 254.148L69.1636 254.148L69.1636 248.084L270.045 248.084L270.045 107.411L276.109 107.411L276.109 254.148Z",
    fill: "url(#paint7_linear_908_1871)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.3828 74.6396H241.964V80.7037H53.4469V136.268H47.3828V74.6396Z",
    fill: "url(#paint8_linear_908_1871)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M291.367 251.918L282.271 267.673L264.079 267.673L254.983 251.918L264.079 236.163L282.271 236.163L291.367 251.918Z",
    fill: "#F8F9F9"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.865 251.919L284.019 270.706L262.325 270.706L251.478 251.919L262.325 233.132L284.019 233.132L294.865 251.919ZM280.517 239.196L265.826 239.196L258.481 251.919L265.826 264.642L280.517 264.642L287.863 251.919L280.517 239.196Z",
    fill: "url(#paint9_linear_908_1871)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.1992 111.433H242.269V220.625H86.1992V111.433ZM92.2633 117.497V214.561H236.205V117.497H92.2633Z",
    fill: "url(#paint10_linear_908_1871)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0176 78.0812L59.9214 93.8361L41.7291 93.8361L32.633 78.0812L41.7291 62.3262L59.9214 62.3262L69.0176 78.0812Z",
    fill: "#F8F9F9"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.5195 78.081L61.6728 96.868L39.9794 96.868L29.1327 78.081L39.9794 59.2939L61.6728 59.2939L72.5195 78.081ZM58.1717 65.358L43.4805 65.358L36.1349 78.081L43.4805 90.8039L58.1717 90.8039L65.5173 78.081L58.1717 65.358Z",
    fill: "url(#paint11_linear_908_1871)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7402 78.0813L46.783 85.0835L54.8684 85.0835L58.9112 78.0813L54.8684 71.0791L46.783 71.0791L42.7402 78.0813Z",
    fill: "url(#paint12_linear_908_1871)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M265.09 251.918L269.133 258.92L277.218 258.92L281.261 251.918L277.218 244.916L269.133 244.916L265.09 251.918Z",
    fill: "url(#paint13_linear_908_1871)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6973 160.549L44.5569 170.698L56.276 170.698L62.1356 160.549L56.276 150.399L44.5569 150.399L38.6973 160.549Z",
    fill: "#F8F9F9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1953 160.548L42.8055 173.729L58.0257 173.729L65.6359 160.548L58.0257 147.367L42.8055 147.367L35.1953 160.548ZM46.3066 153.431L54.5246 153.431L58.6337 160.548L54.5246 167.665L46.3066 167.665L42.1975 160.548L46.3066 153.431Z",
    fill: "#DEECF8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6973 200.159L44.5569 210.308L56.276 210.308L62.1356 200.159L56.276 190.01L44.5569 190.01L38.6973 200.159Z",
    fill: "#F8F9F9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1953 200.159L42.8055 213.34L58.0257 213.34L65.6359 200.159L58.0257 186.978L42.8055 186.978L35.1953 200.159ZM46.3066 193.042L54.5246 193.042L58.6337 200.159L54.5246 207.276L46.3066 207.276L42.1975 200.159L46.3066 193.042Z",
    fill: "#DEECF8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6973 239.769L44.5569 249.918L56.276 249.918L62.1356 239.769L56.276 229.62L44.5569 229.62L38.6973 239.769Z",
    fill: "#F8F9F9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.1953 239.769L42.8055 252.95L58.0257 252.95L65.6359 239.769L58.0257 226.588L42.8055 226.588L35.1953 239.769ZM46.3066 232.652L54.5246 232.652L58.6337 239.769L54.5246 246.886L46.3066 246.886L42.1975 239.769L46.3066 232.652Z",
    fill: "#DEECF8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M257.004 78.0816L265.089 92.086L281.26 92.086L289.346 78.0816L281.26 64.0771L265.089 64.0771L257.004 78.0816Z",
    fill: "#F8F9F9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M253.504 78.0814L263.34 95.1179L283.012 95.1179L292.848 78.0814L283.012 61.0449L263.34 61.0449L253.504 78.0814ZM266.841 67.109L279.511 67.109L285.846 78.0814L279.511 89.0538L266.841 89.0538L260.506 78.0814L266.841 67.109Z",
    fill: "#DEECF8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 321,
    height: 327,
    stroke: "#D3DEFB",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_908_1871",
    x1: 397.984,
    y1: 0.0000160772,
    x2: 118.448,
    y2: 312.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F7FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_908_1871",
    x1: 191.975,
    y1: 155.506,
    x2: 193.696,
    y2: 186.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_908_1871",
    x1: 102.489,
    y1: 195.812,
    x2: 103.246,
    y2: 221.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_908_1871",
    x1: 184.525,
    y1: 195.812,
    x2: 185.281,
    y2: 221.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_908_1871",
    x1: 144.008,
    y1: 130.666,
    x2: 146.418,
    y2: 174.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_908_1871",
    x1: 132.8,
    y1: 184.092,
    x2: 133.943,
    y2: 221.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_908_1871",
    x1: 107.598,
    y1: 155.506,
    x2: 109.319,
    y2: 186.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_908_1871",
    x1: 276.109,
    y1: 120.439,
    x2: 66.2381,
    y2: 139.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_908_1871",
    x1: 47.3828,
    y1: 130.796,
    x2: 238.503,
    y2: 92.1255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_908_1871",
    x1: 255.331,
    y1: 233.132,
    x2: 257.456,
    y2: 271.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_908_1871",
    x1: 86.1992,
    y1: 210.931,
    x2: 244.44,
    y2: 196.437,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_908_1871",
    x1: 32.9848,
    y1: 59.2939,
    x2: 35.1103,
    y2: 97.5925,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_908_1871",
    x1: 57.4754,
    y1: 71.0791,
    x2: 56.6832,
    y2: 85.3536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_908_1871",
    x1: 279.825,
    y1: 244.916,
    x2: 279.033,
    y2: 259.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1244C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#225AEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2490F4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtendedTeam);
export default __webpack_public_path__ + "static/media/extended-team.49366d2fa1e95091c431cc2f44b1cb2b.svg";
export { ForwardRef as ReactComponent };